import React from 'react';
import PropTypes from 'prop-types';

import { Link, Chip } from '@mui/material';
const PartnerCategories = ({ categories }) =>
  categories
    ? categories.map(({ name, slug }) => (
        <Chip
          label={name}
          component={Link}
          to={`/partner/${slug}/`}
          size="small"
          variant="outlined"
          sx={{ marginRight: 1 }}
          clickable
        />
      ))
    : null;

PartnerCategories.propTypes = {
  categories: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};

export default PartnerCategories;
